export { default } from './WorkExperience';


// WEBPACK FOOTER //
// ./src/pages/WorkExperience/index.js